import AttributionPage from "@/components/attribution/AttributionPage";
import { PageTour } from "@/components/tour/PageTour";
import { attributionSteps } from "@/lib/tour-steps";

export default function AdminAttribution() {
  return (
    <>
      <PageTour steps={attributionSteps} tourId="attribution" />
      <AttributionPage />
    </>
  );
}
